<template>
	<div v-if="userRole === 'admin'" class="tenant-select">
		<v-select v-model="currentTenant" @input="switchTenant" label="company_name" :options="tenants" :clearable="false"></v-select>
	</div>
</template>

<script>
import Axios from 'axios'

export default {
	data() {
		return {
			userRole: '',
			tenants: [],
			currentTenant: {}
		}
	},
	computed: {
		tenant() {
			return this.$store.getters['tenant/get']
		}
	},
	methods: {
		switchTenant(tenant) {
			this.$store.commit('app/setLoading', true)
			Axios.post(`/api/v1/admin/tenant/${tenant.id}`)
			.then(res => {
				this.$store.commit('tenant/set', res.data)
				this.$store.commit('app/setLoading', false)
				this.$router.go()
			})
			.catch(err => {
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'An Error occurred, please try later',
					timeout: 3000
				})
				this.$store.commit('app/setLoading', false)
			})
		}
	},
	mounted() {
		const self = this

		this.userRole = localStorage.getItem('userRole')

		if(this.userRole === 'admin') {
			Axios.get('/api/v1/admin/tenants')
			.then(res => {
				this.tenants = res.data
				this.currentTenant = this.tenants.find(item => {
					return self.tenant.id == item.id
				})
			})
			.catch(err => console.log(err))
		}
	},
}
</script>

<style lang='scss'>

</style>


// WEBPACK FOOTER //
// src/components/Header/TenantSelect.vue